import { css } from 'styled-components';
import { withUnit } from '../core/withUnit.js';

const padding = css `
  padding: ${props => withUnit(props.$padding)};
  padding-top: ${props => withUnit(props.$paddingTop)};
  padding-right: ${props => withUnit(props.$paddingRight)};
  padding-bottom: ${props => withUnit(props.$paddingBottom)};
  padding-left: ${props => withUnit(props.$paddingLeft)};
`;

export { padding };
//# sourceMappingURL=padding.js.map
